import { PrivateAvatar } from '../../../shared/PrivateImage';
import React, { useContext, useState } from 'react';
import { Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, IconButton, Button, CircularProgress } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import axios from 'axios';
import { ContextData } from '../../../../context/Context';
import baseUrl from '../../../../BaseURL'; 
import { toast } from 'react-toastify';

const SearchGen = () => {


  const [searchText, setSearchText] = useState('');
  const [memberData, setMemberData] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const { accesstoken, Person } = useContext(ContextData);

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleSearch = async () => {
    if (!searchText.trim()) {
      toast.warning('Please enter a search ID');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(`${baseUrl}/auth/get_member_datas_for_admin_all/${searchText}`, {
        withCredentials: true,
        headers: { 
          'Accept': 'application/json',
          'authorization': `Bearer ${accesstoken}`
        }
      });
      
      if (response.data) {
        setMemberData(Array.isArray(response.data) ? response.data : [response.data]);
        toast.success('Member found!');
      }
    } catch (err) {
      console.log(err.message);
      toast.error(err.response?.data?.message || 'Member not found');
      setMemberData(null);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };


    const send_member_to_workflow = (usetoken) => {

             if(!usetoken){
                toast.error("Invalid User Token")
                return
             }
                
            axios.put(`${baseUrl}/auth/send_member_to_workflow`,{usetoken},{
              withCredentials: true,
              headers: {
                'Accept' : 'application/json',  
                'authorization': `Bearer ${accesstoken !== null && accesstoken}`
              }}).then(res=>{
                     toast.success(res.data)
              })    
  }


      const SendToIDCard = (usetoken) => {

             if(!usetoken){
                toast.error("Invalid User Token")
                return
             }
                
            axios.put(`${baseUrl}/auth/send_member_to_idcard`,{usetoken},{
              withCredentials: true,
              headers: {
                'Accept' : 'application/json',  
                'authorization': `Bearer ${accesstoken !== null && accesstoken}`
              }}).then(res=>{
                     toast.success(res.data)
              })    
  }

  return (
    <Container>
      <div className='flex justify-between items-center mem-top-point-con'>
        <p className='font-extrabold mt-3'>Search Members</p>
        {memberData && memberData.length > 0 && (
          <p className='font-bold mt-3'>Total Results: {memberData.length}</p>
        )}
      </div>
      
      <TextField
        label="Search by ID,NIN,Email,Mobile Number,State,type 0 for pending ID card"
        variant="outlined"
        value={searchText}
        onChange={handleSearchChange}
        onKeyPress={handleKeyPress}
        InputProps={{
          endAdornment: (
            <IconButton onClick={handleSearch} disabled={loading}>  
              {loading ? <CircularProgress size={24} /> : <SearchIcon />}
            </IconButton>
          ),
        }}
        fullWidth
        margin="normal"
      />

      {memberData && memberData.length > 0 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow sx={{background:"rgb(0, 24, 69)"}}>
                <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>No.</TableCell>
                {(Person?.acc_level === "100" || Person?.acc_level === "90") && (
                  <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Avatar</TableCell>
                )}
                <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Full Name</TableCell>
                {(Person?.acc_level === "100" || Person?.acc_level === "90") && (
                  <>
                    <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Age</TableCell>
                    <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>State</TableCell>
                    <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>LGA</TableCell>
                    <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Mobile</TableCell>
                    <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>R-ID</TableCell>
                    <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Verified</TableCell>
                    <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>ID Card Status</TableCell>
                    <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Send to Workflow</TableCell>
                    <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>To IDCard</TableCell>

                  </>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {memberData.map((user, index) => (
                <TableRow key={user.id || index}>
                  <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{index + 1}</TableCell>
                  
                  {(Person?.acc_level === "100" || Person?.acc_level === "90") && (
                    <TableCell>
                      <PrivateAvatar
                        title={user.picture} 
                        sx={{boxShadow:'2px 2px 10px rgba(0,0,0,0.364)'}} 
                        alt={user.fname} 
                        src={`${baseUrl}/files/assets/MemberPictures/${user.picture}`} 
                      />
                    </TableCell>
                  )}

                  <TableCell align='center' sx={{whiteSpace:"nowrap"}}>
                    {user.fname} {user.lname}
                  </TableCell>

                  {(Person?.acc_level === "100" || Person?.acc_level === "90") && (
                    <>
                      <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.age}</TableCell>
                      <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.stateoforigin}</TableCell>
                      <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.lga}</TableCell>
                      <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.mobile}</TableCell>
                      <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.r_ID}</TableCell>
                      <TableCell align='center' sx={{whiteSpace:"nowrap"}}>
                        {user.acc_status ? 'Yes' : 'No'}
                      </TableCell>
                      <TableCell align='center' sx={{whiteSpace:"nowrap"}}>
                        {user.id_card_status === "0" ? 'No' : 'Yes'}
                      </TableCell>
                        <TableCell align='center' sx={{whiteSpace:"nowrap"}}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => send_member_to_workflow(user.token)}
                        >
                          Send to Workflow
                        </Button>
                      </TableCell>  
                        <TableCell align='center' sx={{whiteSpace:"nowrap"}}>
                        <Button
                          variant="contained"
                          color="secondary"
                          sx={{backgroundColor:"darkorange"}}
                          onClick={() => SendToIDCard(user.token)}
                        >
                          To IDCard
                        </Button>
                      </TableCell>  
                    </>
                  )}
                </TableRow>
              ))}

            </TableBody>
          </Table>
        </TableContainer>
      )}

      {memberData && memberData.length === 0 && (
        <div className='flex justify-center items-center mt-4'>
          <p>No member found</p>
        </div>
      )}
    </Container>
  );
};

export default SearchGen;
